import { render, staticRenderFns } from "./SettingsNavi.vue?vue&type=template&id=1ca5dd54&"
import script from "./SettingsNavi.vue?vue&type=script&lang=js&"
export * from "./SettingsNavi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports